var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-app',[_c('b-row',[_c('b-col',[_c('b-carousel',{attrs:{"id":"carousel-1","interval":4000,"background":"#ababab","img-width":"290.500","img-height":"54.375","controls":"","indicators":""}},_vm._l((_vm.items),function(i){return _c('b-carousel-slide',{key:i.id,attrs:{"img-src":i.src}})}),1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }